import request from '@/services/interceptor.js'

export const get_kpi = () => {
    return request({
        url: '/dashboard/kpi',
        method: 'get',
        loadingBar: true
    })
}